// Mirrors the backend ProductType values the checkout's "Lighting Option"
// select posts. Alleen gat (holes only) used to be 36 here, which is
// ProductType.Zonwering on the backend — it never left the internal calculator.
export enum enumLedType {
    Led_Normaal = 34,
    Led_Dimbaar = 35,
    Alleen_Gat = 115
}
